import { type CardsModel } from '../types';
import { autoDisablePayload, autoDisableToInput } from './autoDisable';
import { parseStringToNumber } from './parseNumber';

export interface TCardEditValues {
  newDescription?: string;
  newLimit?: string;
  newMinIncome?: string | number;
  newMaxIncome?: string | number;
  newInstantOrders?: string;
  newDailyLimit?: string;
  newMonthlyLimit?: string;
  newDailyLimitEnabled?: boolean;
  newMonthlyLimitEnabled?: boolean;
  newAutoDisableSuccesses?: string;
  newAutoDisableTimeouts?: string;
}

// Every editable field of the card, so a column hidden in the table is saved unchanged instead of empty.
export const cardEditValues = (card: CardsModel): TCardEditValues => ({
  newDescription: card.description ?? '',
  newLimit: String(card.total_limit ?? '0'),
  newMinIncome: String(card.min_income ?? 0),
  newMaxIncome: String(card.max_income ?? 0),
  newInstantOrders: String(card.instant_active_orders ?? 0),
  newDailyLimit: String(card.daily_total_limit || '0'),
  newMonthlyLimit: String(card.monthly_total_limit || '0'),
  newDailyLimitEnabled: !!card.daily_limit_enabled,
  newMonthlyLimitEnabled: !!card.monthly_limit_enabled,
  newAutoDisableSuccesses: autoDisableToInput(card.auto_disable_after_successes),
  newAutoDisableTimeouts: autoDisableToInput(card.auto_disable_after_timeouts),
});

export const cardEditBody = (data: TCardEditValues) => ({
  total_limit: parseStringToNumber(data.newLimit),
  description: data.newDescription ?? '',
  min_income: +(data.newMinIncome ?? 0),
  max_income: +(data.newMaxIncome ?? 0),
  instant_active_orders: parseStringToNumber(data.newInstantOrders),
  daily_total_limit: parseStringToNumber(data.newDailyLimit || '0'),
  monthly_total_limit: parseStringToNumber(data.newMonthlyLimit || '0'),
  daily_limit_enabled: !!data.newDailyLimitEnabled,
  monthly_limit_enabled: !!data.newMonthlyLimitEnabled,
  ...autoDisablePayload(data.newAutoDisableSuccesses, data.newAutoDisableTimeouts),
});
